import React, { useEffect, useState } from 'react';
import MainWrapper from '../../components/MainWrapper';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Message from '../../utils/Message';
import Loader from '../../utils/Loader';
import {
  getAllAccountsByProject,
  deleteAccount,
} from '../../actions/accountActions';
import { AiTwotoneEdit, AiFillDelete } from 'react-icons/ai';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';
import DriveWrapper from './components/DriveWrapper';


const AccountsDrive = ({ match }) => {
  const dispatch = useDispatch();
  const [projectId, setProjectId] = useState('');
  const searchParams = useParams();
  const { id } = searchParams;

  useEffect(() => {
    if (id) {
      setProjectId(id);
      dispatch(getAllAccountsByProject(id));
    }
  }, [dispatch, id]);

  const { accounts, error, loading } = useSelector((state) => state.accountR);


  function delAccount(accountId) {
    Swal.fire({
      // title: 'Are you sure?',
      text: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteAccount(accountId));
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        return;
      }
    });
  }

  return (
    <DriveWrapper>
      {error ? (
        <Message color="danger">{error} </Message>
      ) : loading ? (
        <Loader />
      ) : (
        <div className="container">
          <div className="d-flex justify-content-between align-items-center ">
            <h5 className="lead">Account Setting</h5>
            <Link to={`/drive/account/add/${projectId}`}>
              <button className="btn btn-success">Add Account</button>
            </Link>
          </div>

          <div className="py-3">
            {loading && <Loader />}
            {error && <Message color="danger">{error} </Message>}
          </div>

          <div className="container">
            {accounts &&
              accounts.map((account, i) => {
                return (
                  <div
                    key={i}
                    className="accordion"
                    id="accordionExample"
                    style={{ color: '#1E5162' }}
                  >
                    <div className="accordion-item mb-4">
                      <h2 className="accordion-header" id={'headingOne' + i}>
                        <div
                          className="accordion-button"
                          data-bs-toggle="collapse"
                          data-bs-target={'#panelsStayOpen-' + i}
                          aria-expanded="true"
                          aria-controls={'panelsStayOpen-' + i}
                        >
                          {account.username} ({account.role})
                        </div>
                      </h2>
                      <div
                        id={'panelsStayOpen-' + i}
                        className="accordion-collapse collapse show"
                        aria-labelledby={'headingOne' + i}
                      >
                        <div className="accordion-body d-block">
                          <div className="fw-bold">
                            Report To Access :
                            <div className="d-flex flex-wrap mt-2">
                              {account.report2Access.map((report, idx) => {
                                return (
                                  <div
                                    key={idx}
                                    className="px-1 py-1 border me-1 my-1"
                                  >
                                    {report.label}
                                  </div>
                                );
                              })}
                            </div>
                          </div>

                          <div className="d-flex justify-content-end ">
                            <Link
                              to={`/drive/account/edit/${account._id}/${projectId}`}
                              key={i}
                            >
                              <AiTwotoneEdit />
                            </Link>
                            <div
                              className="ms-3"
                              style={{ cursor: 'pointer' }}
                              onClick={() => delAccount(account._id)}
                            >
                              <AiFillDelete color="#ff726f" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    </DriveWrapper>
  );
};

export default AccountsDrive;
